function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
var Thumbnails = function () {
    function Thumbnails(options) {
        _classCallCheck(this, Thumbnails);
        this.container = options.container;
        this.barWidth = options.barWidth;
        this.events = options.events;
        this.isShow = true;
        if (options.url)
            this.container.style.backgroundImage = 'url(\''.concat(options.url, '\')');
        else
            this.hide();
    }
    _createClass(Thumbnails, [
        {
            key: 'reload',
            value: function reload(url) {
                if (url) {
                    this.container.style.backgroundImage = 'url(\''.concat(url, '\')');
                } else {
                    this.container.style.backgroundImage = null;
                    this.hide();
                }
            }
        },
        {
            key: 'resize',
            value: function resize(width, height, barWrapWidth) {
                this.container.style.width = ''.concat(width, 'px');
                this.container.style.height = ''.concat(height, 'px');
                this.container.style.top = ''.concat(-height - 10, 'px');
                if (barWrapWidth) {
                    this.barWidth = barWrapWidth;
                }
            }
        },
        {
            key: 'show',
            value: function show() {
                if (this.container.style.backgroundImage) {
                    this.container.style.display = 'block';
                    this.isShow = true;
                    this.events && this.events.trigger('thumbnails_show');
                }
            }
        },
        {
            key: 'move',
            value: function move(position) {
                if (this.container.style.backgroundImage) {
                    this.show();
                    this.container.style.backgroundPosition = '-'.concat((Math.ceil(position / this.barWidth * 50) - 1) * 160, 'px 0');
                    this.container.style.left = ''.concat(Math.min(Math.max(position - this.container.offsetWidth / 2, 0), this.barWidth - 160), 'px');
                }
            }
        },
        {
            key: 'hide',
            value: function hide() {
                this.container.style.display = 'none';
                this.isShow = false;
                this.events && this.events.trigger('thumbnails_hide');
            }
        }
    ]);
    return Thumbnails;
}();
export default Thumbnails;